import React, { useState } from "react";
import {
  Container,
  Card,
  CardBody,
  Button,
  Input
} from "reactstrap";
import { useHistory } from "react-router-dom";
import UiContent from "../../Components/Common/UiContent";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import RecordDescriptionModal from "./RecordDescriptionModal";
import { postDataAPI } from "../../helpers/phpbackend_helper";

const VOICE_FIELDS = {
  description: "description",
  phrases: "phrases",
  standards: "standards"
};

const CreateScenario = () => {
  const history = useHistory();

  const [scenarioName, setScenarioName] = useState("");
  const [description, setDescription] = useState("");
  const [phrases, setPhrases] = useState("");
  const [standards, setStandards] = useState("");
  const [showRecordModal, setShowRecordModal] = useState(false);
  const [voiceTarget, setVoiceTarget] = useState(null);
  const [loading, setLoading] = useState(false);

  const fieldSetters = {
    [VOICE_FIELDS.description]: setDescription,
    [VOICE_FIELDS.phrases]: setPhrases,
    [VOICE_FIELDS.standards]: setStandards
  };

  const openRecord = (field) => {
    setVoiceTarget(field);
    setShowRecordModal(true);
  };

  const applyVoiceText = (text) => {
    const setter = fieldSetters[voiceTarget];
    if (setter) setter(text);
    setShowRecordModal(false);
    setVoiceTarget(null);
  };

  const createScenario = async () => {
    if (!scenarioName.trim()) {
      alert("Please enter a scenario name");
      return;
    }
    if (!description.trim()) {
      alert("Please describe the scenario");
      return;
    }
    if (!phrases.trim()) {
      alert("Please add must-use phrases / wording");
      return;
    }
    if (!standards.trim()) {
      alert("Please add service standards");
      return;
    }

    try {
      setLoading(true);
      const res = await postDataAPI({
        serviceName: "item_data",
        op: "create_update_scenario",
        scenario_name: scenarioName.trim(),
        description: description.trim(),
        phrases: phrases.trim(),
        standards: standards.trim()
      });

      if (res.status === "ok") {
        history.push("/server-performance-coaching");
        return;
      }
      alert(res.message || "Scenario creation failed");
    } catch (err) {
      alert("Scenario creation failed");
    } finally {
      setLoading(false);
    }
  };

  const renderVoiceTextarea = ({ label, icon, value, onChange, field, placeholder }) => (
    <div className="mb-4">
      <div className="d-flex align-items-center gap-2 mb-2">
        <i className={`${icon} text-warning`}></i>
        <span className="fw-medium">{label}</span>

        <div className="ms-auto">
          <Button size="sm" outline onClick={() => openRecord(field)}>
            <i className="ri-mic-line me-1" /> Record
          </Button>
        </div>
      </div>

      <Input
        type="textarea"
        rows="5"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  );

  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Create Scenario"
            pageTitle="Dashboard &nbsp; > &nbsp; Server Performance Coaching"
          />

          <Card className="border-0 shadow-sm">
            <CardBody
              className="p-4"
              style={{
                background: "linear-gradient(135deg, #eef6fb, #f9fcff)",
                borderRadius: 12
              }}
            >
              <div className="mb-3">
                <Button
                  outline
                  className="mb-3"
                  onClick={() => history.push("/server-performance-coaching")}
                >
                  ⬅ Back
                </Button>
                <h4 className="fw-bold mb-1">Add new Scenario</h4>
              </div>

              <div className="mb-4">
                <label className="fw-medium mb-1">Scenario Name</label>
                <Input
                  type="text"
                  value={scenarioName}
                  onChange={(e) => setScenarioName(e.target.value)}
                  placeholder="Enter scenario name"
                />
              </div>

              {renderVoiceTextarea({
                label: "Describe Scenario",
                icon: "ri-file-text-line",
                value: description,
                onChange: (e) => setDescription(e.target.value),
                field: VOICE_FIELDS.description,
                placeholder: "Describe the scenario..."
              })}

              {renderVoiceTextarea({
                label: "Must-use phrases / wording",
                icon: "ri-chat-quote-line",
                value: phrases,
                onChange: (e) => setPhrases(e.target.value),
                field: VOICE_FIELDS.phrases,
                placeholder: "Add phrases or wording that must be used..."
              })}

              {renderVoiceTextarea({
                label: "Service Standards",
                icon: "ri-star-line",
                value: standards,
                onChange: (e) => setStandards(e.target.value),
                field: VOICE_FIELDS.standards,
                placeholder: "Describe the service standards..."
              })}

              <Button color="primary" block onClick={createScenario} disabled={loading}>
                {loading ? "Creating..." : "✔ Create Scenario"}
              </Button>
            </CardBody>
          </Card>

          <RecordDescriptionModal
            isOpen={showRecordModal}
            dishName={scenarioName}
            onClose={() => {
              setShowRecordModal(false);
              setVoiceTarget(null);
            }}
            onSave={applyVoiceText}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CreateScenario;
